module.exports = __webpack_public_path__ + "img/portrait_unknown@3x.4c4b82ff.png";